import React, { Component } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const NOTIK_QUERY = gql`
  query notikumiQuery($lang: LanguageCodeFilterEnum,$cursor: String) {
    notikumi(where: { language: $lang },first: 6, after: $cursor) {
      edges {
        node {
          id
          galerija {
            gallery {
              sourceUrl(size: MEDIUM_LARGE)
            }
          }
          title
          slug
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    themeGeneralSettings {
      optionsPage {
        gimmeMore
        gimmeMoreEn
      }
    }
  }
`;

class Notik extends Component {
  render() {
    const {
      data: { loading, errors, notikumi }
    } = this.props;
    // console.log(this.props);
    return (

        <div id = "notikumi"
        data-headertitle = {
            cookies.get("lang") === "LV" ? "Notikumi" : cookies.get("lang") === "EN" ? "Events" : null
                } className="container notikumi-container">
        <div className="row">
          {loading && <div className="loader" />}
          {errors && <div className="errors">...</div>}

          {!loading && !notikumi && (
            <span className="none">Nav notikumu...</span>
          )}

          {!loading &&
            notikumi &&
            notikumi.edges.map((prop, i) => (
              <div className="col-6 col-md-4 notikumi-single-card" key={i}>
                <div className="galWrap">
                  <div
                    className="notikumi-single-card-wrap"
                    style={{
                      backgroundImage: `url(${prop.node.galerija.gallery[0].sourceUrl})`
                    }}
                  >
            <Link
              to={`/${cookies.get("lang").toLowerCase()}/notikumi/${prop.node.slug}`}
              className="notikumi-single-card-a"
            >
              <div className="notikumi-single-card-a-text">
                {prop.node.title}
              </div>
            </Link>
                  </div>
                </div>
              </div>
            ))}

          {!loading && notikumi && notikumi.pageInfo.hasNextPage === true && (
            <div className="loadMoreWrap mb-5">
              <button onClick={this.onFetchMore}>
                {cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage.gimmeMore}
                {cookies.get("lang") === "EN" &&
                  this.props.data.themeGeneralSettings.optionsPage.gimmeMoreEn}
              </button>
            </div>
          )}
        </div>
        </div>
    );
  }
  onFetchMore = () => {
    const {
      data: { notikumi, fetchMore }
    } = this.props;
    //console.log(this.props);

    fetchMore({
      variables: {
        cursor: notikumi.pageInfo.endCursor
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newEdges = fetchMoreResult.notikumi.edges;
        const pageInfo = fetchMoreResult.notikumi.pageInfo;

        return newEdges.length
          ? {
              // Put the new pages at the end of the list and update `pageInfo`
              // so we have the new `endCursor` and `hasNextPage` values
              notikumi: {
                __typename: previousResult.notikumi.__typename,
                edges: [...previousResult.notikumi.edges, ...newEdges],
                pageInfo
              }
            }
          : previousResult;
      }
    });
  };
}
//export default graphql(NOTIK_QUERY)(Notik);
    const cookieLang = cookies.get("lang");

export default graphql(NOTIK_QUERY, {
  options: (props) => ({ variables: { lang: cookieLang } })
})( Notik );